import Bowser from "bowser";

export enum PlatformAuthenticatorAlias {
  WINDOWS_HELLO = "Windows Hello",
  APPLE = "Touch ID/Face ID",
  ANDROID = "Android Biometrics",
  NONE = "Platform Authenticator"
}

export function getPlatformAuthenticatorAlias(userAgent: string): string {
  const { os } = Bowser.getParser(userAgent).getResult()

  if (os.name === "Windows") {
    return PlatformAuthenticatorAlias.WINDOWS_HELLO
  }

  if (os.name === "Android") {
    return PlatformAuthenticatorAlias.ANDROID
  }

  if (os.name === "macOS" || os.name === "iOS") {
    return PlatformAuthenticatorAlias.APPLE
  }

  return PlatformAuthenticatorAlias.NONE
}


